// Auto-refactored from translations.js on 2026-08-19
// Locale: pt

const pt = {
  wieMoeglich: { question: 'Como isso é possível?', answer: 'Repensámos a cadeia de valor.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'O caminho STIG ROCK',
    fazit: 'A cadeia de fornecimento encurtada elimina as maiores posições de custo.',
    fazitBigPre: 'Isto permite um desconto de até',
    fazitBigValue: '80%',
    steps: [ 'Mina', 'Lapidação', 'Certificação', 'Cliente final' ]
  },
  nav: { language: 'Idioma', contact: 'Contacto' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Uma oportunidade única',
    subtitle: 'Construir património orientado para o futuro.',
    description: 'A STIG ROCK é uma plataforma internacional que oferece às pessoas acesso a diamantes naturais, crescimento patrimonial sustentável e uma comunidade única.',
    scroll: 'Deslize para descobrir'
  },
  disclaimer: {
    overline: 'Aviso Legal',
    title: 'Disclaimer',
    paragraphs: [
      'Esta apresentação serve apenas para fins informativos e não constitui aconselhamento financeiro, de investimento ou fiscal.',
      'STIG ROCK não é um produto financeiro, mas refere-se a diamantes naturais como ativos tangíveis.',
      'Não é garantido qualquer desempenho, lucro ou rendimento. Resultados passados não são indicativos de resultados futuros.',
      'Todos os cálculos apresentados relativos a comissões são meramente exemplificativos e não constituem uma garantia.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'CONSTRUÍDO', 'SOBRE ESTRUTURA' ],
    body: 'STIG Group é um grupo internacional, construído sobre clareza, responsabilidade e valor a longo prazo. Cada marca, projeto e parceria segue um padrão único — sem atalhos, sem exceções.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'CONSTRUÍDO', 'SOBRE ESTRUTURA' ],
        body: 'STIG Group é um grupo internacional, construído sobre clareza, responsabilidade e valor a longo prazo. Cada marca, projeto e parceria segue um padrão único — sem atalhos, sem exceções.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'O MUNDO DOS', 'DIAMANTES EXCLUSIVOS' ],
        body: 'STIG ROCK é um conceito moderno do STIG Group que combina diamantes de alta qualidade certificados pela GIA com estruturas transparentes e uma experiência de cliente exclusiva. Planos de solução claros, execução profissional e orientação internacional.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'COMÉRCIO INTERNACIONAL', 'DE DIAMANTES' ],
        body: 'STIG International faz parte do STIG Group e especializa-se no comércio internacional de diamantes certificados pela GIA. Foco na qualidade, confiança e estruturas comerciais modernas com parcerias globais.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABILIDADE', 'DESDE A MINA' ],
        body: 'Ethical Mines representa a extração responsável, origem rastreável e diamantes livres de conflitos. Da mina ao mercado — documentação completa para transparência, integridade e responsabilidade a longo prazo em toda a cadeia de abastecimento.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamantes',
    stigDrawback: 'Reserva de valor real',
    overline: 'Oportunidades',
    title: 'Oportunidades para a construção de património',
    subtitle: 'Caminhos tradicionais em comparação.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ou Krypto',
        drawback: 'altamente especulativo, imprevisível, complexo'
      },
      {
        tag: 'Aktien',
        name: 'Negociação em bolsa',
        drawback: 'risco de flutuação, conhecimento necessário, tempo exigido'
      },
      {
        tag: 'Krypto',
        name: 'Negociação',
        drawback: 'volatilidade, risco regulatório, falhas de segurança'
      }
    ]
  },
  chance: {
    overline: 'Diamantes',
    title: 'A oportunidade subestimada',
    body: 'Os diamantes estão entre as formas de investimento mais estáveis e promissoras há anos, mas até agora poucos exploraram este potencial.',
    callout: 'Com a nossa STIG ROCK, abrimos pela primeira vez o acesso a estas oportunidades extraordinárias para todos.'
  },
  wertentwicklung: {
    overline: 'Evolução do Valor 1995 — 2025',
    title: 'Uma história sobre valor.',
    usd: 'Dólar Americano',
    usdValue: '-49%',
    diamond: 'Diamantes',
    diamondValue: '+185%',
    note: 'Evolução desde 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Principais Razões',
    title: 'Seis razões para escolher diamantes',
    lead: 'Os diamantes são ativos reais que existem independentemente das moedas e dos sistemas financeiros — e preservam o seu valor há séculos.',
    items: [
      {
        n: '01',
        title: 'Estabilidade de valor à prova de crises',
        body: 'Garantia de ativo tangível. Independente de moedas e sistemas financeiros.'
      },
      {
        n: '02',
        title: 'A derradeira mobilidade',
        body: 'Pequeno, fácil de ocultar e transportar.'
      },
      {
        n: '03',
        title: 'Diversificação & Escassez',
        body: 'Escassez de oferta e limitação natural.'
      },
      { n: '04', title: 'Crescimento a longo prazo', body: '+185% desde 1995.' },
      {
        n: '05',
        title: 'Transparência & Exclusividade',
        body: 'Os 4 Cʼs como garantia: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Reserva das casas reais',
        body: 'Até as casas reais utilizam diamantes como reserva de património.'
      }
    ]
  },
  markt: {
    overline: 'Volume de Mercado',
    title: '99 — 108 Mrd. USD',
    sub: 'Volume de negócios em 2025',
    forecast: 'Previsão até ~2032 / 2034: aprox. 140 – 168 Mrd. USD com crescimento moderado (~4 – 5 % p.a.).',
    source: 'Fonte: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovação',
    title: 'Uma inovação. Pela primeira vez no mundo.',
    body: 'STIG ROCK é a primeira plataforma mundial que permite gerar rendimento passivo no mercado de diamantes, além da valorização de ativos.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, EAU',
      'N.º de Registo DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Sobre a Empresa',
    titleLines: [ 'ESTRUTURA', 'INTERNACIONAL', 'VISÃO CLARA' ],
    body: 'STIG ROCK foi fundada para tornar o mercado de diamantes mais transparente, moderno e focado no cliente — com foco na confiança, segurança e estrutura a longo prazo.'
  },
  sicherheit: {
    overline: 'Qualidade & Segurança',
    title: 'Gemological Institute of America',
    body: 'Experiência certificada para os seus diamantes. A GIA avalia cada pedra com a máxima precisão e anos de experiência — avaliações fiáveis para a nossa empresa e os nossos clientes.',
    transparency: 'Cada diamante cumpre os mais elevados padrões de qualidade e é testado e certificado por organizações de renome. Cada pedra é única e recebe um certificado individual.',
    kimberley: 'Kimberley Process — trabalhamos exclusivamente com diamantes livres de conflitos.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Uma inovação de produto única',
    sub: 'Seis Solution Pläne escalonados — de $1K a $100K+, cada um com desconto crescente por mês e durante todo o período.',
    recommended: 'Popular',
    oneYear: '1 ano',
    rowLabels: {
      delivery: 'Prazo de entrega',
      price: 'Preço do Produto',
      carat: 'Karat',
      monthly: 'Desconto (Mês)',
      totalDiscount: 'Desconto (Total)',
      duration: 'Duração'
    },
    headers: {
      plan: 'Plano',
      from: 'Desde',
      carat: 'Karat',
      monthly: 'Desconto / Mês',
      total: 'Desconto Total',
      duration: 'Duração'
    },
    duration: '1 ano',
    footnote: 'Todos os preços são meramente indicativos e dependem da qualidade, procura e evolução atual do mercado. Os Solution Pläne da Solution também estão disponíveis por 2 anos.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Pacote VIP',
    title: 'Ainda mais desconto com o Pacote VIP',
    sub: 'Desconto total por plano – combinado com um Pacote VIP, recebe +1% a +3% adicionais, o que aumenta significativamente o desconto total.',
    rowLabels: {
      delivery: 'Prazo de entrega',
      price: 'Preço do Produto',
      carat: 'Karat',
      monthly: 'Desconto (Mês)',
      totalDiscount: 'Desconto (Total)',
      vip1: 'Pacote VIP 1 (+1%)',
      vip2: 'Pacote VIP 2 (+2%)',
      vip3: 'Pacote VIP 3 (+3%)'
    },
    footnote: 'Todos os preços são meramente indicativos e dependem da qualidade, procura e evolução atual do mercado.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'As suas possibilidades',
    sub: 'Após o termo do seu Solution Plan, pode revender-nos os seus diamantes ou solicitá-los para entrega na sua residência.',
    options: [
      {
        key: 'deliver',
        title: 'Solicitar entrega',
        body: 'Diamantes (Karat) ao preço do seu DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'Vender-nos',
        body: 'Pode revender-nos os seus diamantes pelo preço de compra pago por si.'
      },
      {
        key: 'sellThirdParty',
        title: 'Vender a terceiros',
        body: 'Pode revender os seus diamantes a terceiros.'
      }
    ],
    footnote: '*DS-Plan refere-se ao Solution Plan.'
  },
  tradWeg: {
    overline: 'Comércio Tradicional',
    title: 'O caminho tradicional',
    sub: 'Antes de um diamante chegar ao cliente final, surgem margens comerciais significativas através do comércio intermediário, grossista e retalhista, em comparação com o preço do diamante em bruto na mina.',
    steps: [
      { title: 'Mina', subtitle: 'Diamantes em bruto' },
      { title: 'Intermediário', subtitle: 'Compra de diamantes em bruto' },
      { title: 'Lapidação', subtitle: 'Corte para diamantes de joalharia' },
      { title: 'Certificação', subtitle: 'por institutos reconhecidos como GIA' },
      { title: 'Bolsa de Diamantes', subtitle: 'Venda ao comércio grossista' },
      { title: 'Grosso', subtitle: 'Venda ao retalho' },
      { title: 'Retalho', subtitle: 'ex. Joalheiros' },
      { title: 'Clientes finais', subtitle: 'Compra de diamantes' }
    ]
  },
  stigWeg: {
    overline: 'STIG ROCK',
    title: 'O caminho STIG ROCK',
    sub: 'Rompemos este ciclo comprando diamantes em bruto diretamente na mina, lapidando-os e certificando-os através dos nossos parceiros. Isto permite-nos repassar estas margens comerciais aos nossos clientes sob a forma de créditos de desconto.',
    duration: '12 meses – Vigência do DS-Plan',
    centerBig: '04',
    centerCaption: 'Até 4 ciclos comerciais durante a vigência do DS-Plan',
    cycle: [
      { n: '1.', title: 'Compra de vários diamantes em bruto', body: 'para um DS-Plan' },
      { n: '2.', title: 'Lapidação e certificação', body: 'através dos nossos parceiros' },
      { n: '3.', title: 'Venda a clientes finais', body: 'e grossistas' },
      { n: '4.', title: 'Repetimos este processo', body: 'até 4× por ano' }
    ],
    steps: [
      { title: 'Mina', subtitle: 'Diamantes em bruto' },
      { title: 'Lapidação', subtitle: 'pelos nossos parceiros' },
      { title: 'Certificação', subtitle: 'por institutos reconhecidos' },
      { title: 'Clientes finais', subtitle: 'Compra & créditos de desconto' }
    ],
    footnote: '*DS-Plan refere-se ao Solution Plan.'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Pacotes VIP',
    sub: 'Válido por 12 meses para todos os Solution Pläne subscritos por si. Dependendo do Pacote VIP: +1% a +3% de desconto adicional',
    cardKicker: 'adicional – em todos os',
    cardKicker2: 'Solution Pläne',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Os descontos tornam-se poupanças',
      body: 'Poupança mensal em vez de encargo mensal. Os descontos geram poupanças – e estas pagam exatamente as coisas pelas quais costuma pagar do seu próprio bolso todos os meses.',
      line1Label: 'DS-Plan desde',
      line1Value: '$5.000',
      line2Label: 'desc. mensal',
      line2Value: '3%',
      line3Label: 'Pacote VIP 3',
      line3Value: '+3%',
      resultLabel: 'poupança mensal',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Como é que isto é possível?',
    title: 'Repensámos a cadeia de valor.',
    traditionalTitle: 'O caminho tradicional',
    traditionalSteps: [
      'Mina — Diamantes em bruto',
      'Intermediário — Compra',
      'Lapidação — Corte',
      'Certificação (GIA)',
      'Bolsa de Diamantes — Grosso',
      'Grosso → Retalho',
      'Joalheiros → Cliente final'
    ],
    traditionalNote: 'Antes de um diamante chegar ao cliente final, surgem margens comerciais significativas através do comércio intermediário, grossista e retalhista.',
    stigTitle: 'O caminho STIG ROCK',
    stigSteps: [
      'Compra Direta — Diamantes em bruto na mina',
      'Lapidação & Certificação pelos nossos parceiros',
      'Venda a clientes finais & clientes B2B',
      'Até 4 ciclos comerciais por ano'
    ],
    stigNote: 'Rompemos o ciclo e repassamos as margens comerciais aos nossos clientes como créditos de desconto — até 4 ciclos comerciais durante a vigência do DS-Plan.'
  },
  optionen: {
    overline: 'As suas possibilidades',
    title: 'Após o termo do seu Solution Plan',
    items: [
      { title: 'Solicitar entrega', body: 'Diamantes (Karat) ao preço do seu DS-Plan.' },
      { title: 'Vender-nos', body: 'Recompra ao preço de compra pago por si.' },
      { title: 'Vender a terceiros', body: 'Venda de diamantes no mercado livre.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Pläne — uma inovação de produto única',
    title: 'O caminho simples',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registo',
        body: 'Contacte o seu recomendador e crie uma conta gratuita!'
      },
      {
        n: '02',
        icon: 'cart',
        title: 'Compra de um produto',
        body: 'A partir de apenas $ 250,-'
      },
      {
        n: '03',
        icon: 'discount',
        title: 'Receber descontos',
        body: 'Receba créditos de desconto mensais.'
      }
    ]
  },
  business: {
    overline: 'Tipos de Bónus',
    title: 'O caminho mais simples e justo.',
    sub: 'Cinco tipos de bónus — para o sucesso na construção do seu negócio.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Até ao nível 3, a partir do nível de carreira Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'A partir de Sapphire — profundidade infinita.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Sobre o Infinity Bonus – até ao nível 5 · SEM qualificação.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pools da faturação mundial.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Bónus único em diamantes (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Este bónus é pago por cada novo Solution Plan subscrito até ao 3.º nível. Com qualificações mínimas, desbloqueia os níveis individuais.',
    total: 'Até 18% Unilevel Bonus',
    levels: [
      {
        level: 'Nível 1',
        value: '10%',
        qual: 'desde o início',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Nível 2',
        value: '5%',
        qual: 'a partir do nível de carreira Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Nível 3',
        value: '3%',
        qual: 'a partir do nível de carreira Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'A partir do nível de carreira Sapphire, está qualificado para o nosso Infinity Bonus. Recebe 3% de bónus. Com cada novo nível de carreira, são adicionadas percentagens extra. Se um parceiro na sua equipa também estiver qualificado, recebe a diferença de nível para nível.',
    exampleTitle: 'Exemplo',
    exampleRows: [
      { label: 'Você é Blue Diamond', value: '12%' },
      { label: 'O seu parceiro é Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'O seu Infinity Bonus', value: '9%' },
    totalNote: 'Total até 24% Infinity Bonus em todos os Solution Pläne subscritos na sua equipa — profundidade infinita.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Com este bónus, beneficia do sucesso da sua equipa. Recebe um Matching Bonus de 5% sobre o Infinity Bonus dos seus parceiros — até ao 5.º nível da sua equipa.',
    note: 'Sobre todos os pagamentos de Infinity Bonus na sua equipa – até ao 5.º nível. Desde o início – SEM qualificação.',
    levels: [
      { level: 'Nível 1', value: '5%' },
      { level: 'Nível 2', value: '5%' },
      { level: 'Nível 3', value: '5%' },
      { level: 'Nível 4', value: '5%' },
      { level: 'Nível 5', value: '5%' }
    ],
    totalPrefix: 'Total até',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% da faturação mundial são distribuídos em partes iguais por 3 pools diferentes. Ao atingir determinados níveis de carreira, qualifica-se para cada pool individual.',
    forever: 'Uma vez alcançado – participação para SEMPRE!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'a partir de Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'a partir de Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'a partir de Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'da faturação mundial'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'A partir do nível de carreira Diamond, recebe um Rang Bonus. Este é pago em diamantes (Karat). Trata-se de um bónus de pagamento único.',
    highlight: 'Diamantes (Karat) num valor total de',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Níveis de Carreira',
    title: 'Níveis de Carreira',
    sub: 'Para atingir os respetivos níveis de carreira, conta o volume de negócios histórico total (HG). A partir do nível Sapphire, este deve ser distribuído por várias equipas. Para atingir Ruby ou superior, necessita de pelo menos dois parceiros diretos com um Solution Plan.',
    forever: 'Uma vez alcançado – confirmado para SEMPRE!',
    footnote: 'HV = Historisches Volumen.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Arranque connosco',
    title: 'O momento certo é agora.',
    body: 'Este modelo de negócio estabelece novos padrões e combina todos os fatores de sucesso para um negócio sustentável e bem-sucedido a longo prazo. Registe-se hoje, escolha o seu Solution Plan e aproveite esta oportunidade de negócio única.',
    hint: 'Fale com a pessoa que o convidou para esta apresentação — ela tem um link de registo para si.',
    formName: 'Nome',
    formEmail: 'E-mail',
    formPhone: 'Telefone',
    formSubmit: 'Entrar em contacto',
    success: 'Muito obrigado — entraremos em contacto de forma discreta e pessoal.',
    callCta: 'Ligar',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Aviso Legal & Disclaimer',
    disclaimer: 'Esta apresentação serve apenas para fins informativos e não constitui aconselhamento financeiro, de investimento ou fiscal. STIG ROCK não é um produto financeiro, mas refere-se a diamantes naturais como ativos tangíveis. Não é garantido qualquer desempenho, lucro ou rendimento. Resultados passados não são indicativos de resultados futuros. Todos os cálculos apresentados relativos a comissões são meramente exemplificativos e não constituem uma garantia. Sujeito a alterações de conteúdo — tradução livre (não oficial).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, EAU',
    copy: '© 2026 STIG International. Todos os direitos reservados.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: 'Próxima Secção' }
};

export default pt;
